<!--
배송등록(수동) 에서 사용되는 상품(1개) 컴포넌트

-->
<template>
    <li class="prod-component">
        <!-- 인덱스 히든 변수 -->
        <input
            type="hidden"
            name="idxs[]"
            :value="index"

        />

        <!-- 순번 -->

        <div class="uk-flex uk-flex-around uk-flex-top uk-flex-wrap">



            <!-- 이미지 영역 -->
            <div class="mr-1rem img">

                <div class="uk-flex uk-flex-center mb-0d5rem">
                    <div class="seq">{{ index + 1 }}</div>
                </div>


                <div class="blank-text" v-show="! columns.p_img_url">
                    상품이미지
                </div>
                <img
                    v-show="columns.p_img_url"
                    :src="columns.p_img_url"
                />

                <div class="uk-flex uk-flex-column uk-flex-middle uk-flex-center mt-1rem">
                    <!-- 업로드버튼 -->
                    <div class="mb-3rem">
                        <button
                            type="button"
                            class="uk-button uk-button-small uk-button-white"
                            @click="$refs.upload.form()"
                        >
                            <i class="material-icons">cloud_upload</i>
                            이미지 업로드
                        </button>

                        <!-- 업로드 컴포넌트 -->
                        <upload
                            :csrf-token="csrfToken"
                            ref="upload"
                            @uploaded="listenUploaded"
                        ></upload>

                        <!-- 업로드 파일 ID -->
                        <input type="hidden" :name="makeInputName('p_img_file_id')" v-model="columns.p_img_file_id" />
                    </div>




                    <!-- 복사버튼 -->
                    <button
                        type="button"
                        class="uk-button uk-button-small uk-button-dg-w-dg mb-1rem"
                        v-on:click="duplicate"
                    >
                        <span uk-icon="icon: copy"></span>
                        {{ duplicateButtonText }}
                    </button>

                    <!-- 삭제버튼 -->
                    <button
                        type="button"
                        class="uk-button uk-button-small uk-button-danger mb-1rem"
                        v-on:click="remove"
                        :disabled="removeButtonDisable"
                    >
                        <span uk-icon="icon: minus-circle"></span>
                        {{ removeButtonText }}
                    </button>

                    <!-- 추가버튼 -->
                    <button type="button" class="mb-1rem uk-button uk-button-small uk-button-black" @click="$emit('add-prod')">
                        <i class="material-icons">add</i>
                        상품추가
                    </button>
                </div>


            </div>

            <div class="uk-width-expand mr-1rem">
                <!-- 상품정보 -->
                <app-shipping-reg-fieldset theme="slim" class="mb-0d5rem" title="상품정보">
                    <div class="uk-flex uk-flex-wrap uk-flex-top">
                        <input-td-style
                            class="w-full mb-0d5rem"
                            type="text"
                            input-size="small"

                            ref="p_name"
                            :name="makeInputName('p_name')"
                            v-model="columns.p_name"
                            label="상품명"

                            :validate-rules="{required: true}"
                            required
                            highlight

                            placeholder="영문 상품명(반드시 영어로 입력해 주세요)"
                        > </input-td-style>

                        <input-td-style
                            class="uk-width-1-2 mb-0d5rem mr-0d5rem"
                            type="text"
                            input-size="small"

                            ref="p_brand"
                            :name="makeInputName('p_brand')"
                            v-model="columns.p_brand"
                            label="브랜드"
                        > </input-td-style>

                        <div class="uk-width-expand mb-0d5rem"></div>

                        <input-td-style
                            class="uk-width-1-2 mb-0d5rem mr-0d5rem"
                            type="text"
                            input-size="small"

                            ref="p_color"
                            :name="makeInputName('p_color')"
                            v-model="columns.p_color"
                            label="색상"

                            :validate-rules="{required: true}"
                            required
                            highlight

                            placeholder="옵션이 없는경우, '-' 입력"
                        > </input-td-style>



                        <input-td-style
                            class="uk-width-expand mb-0d5rem"
                            type="text"
                            input-size="small"

                            ref="p_size"
                            :name="makeInputName('p_size')"
                            v-model="columns.p_size"
                            label="사이즈"

                            :validate-rules="{required: true}"
                            required
                            highlight

                            placeholder="옵션이 없는경우, '-' 입력"
                        > </input-td-style>
                    </div>
                </app-shipping-reg-fieldset>

                <app-shipping-reg-fieldset theme="slim" class="mb-0d5rem" title="가격정보">
                    <div class="uk-flex uk-flex-wrap uk-flex-top">

                        <input-td-style
                            class="uk-width-1-2 mb-0d5rem mr-0d5rem"
                            type="text"
                            input-size="small"

                            ref="p_amount"
                            :name="makeInputName('p_amount')"
                            v-model="columns.p_amount"
                            label="수량"

                            :validate-rules="{required: true, numeric: true}"
                            required
                            highlight

                            placeholder="숫자로만 입력해 주세요"

                            @update:value="emitTotalBuyPrice"
                        > </input-td-style>

                        <input-td-style
                            class="uk-width-expand mb-0d5rem"
                            type="text"
                            input-size="small"

                            ref="p_buy_unit_price"
                            :name="makeInputName('p_buy_unit_price')"
                            v-model="columns.p_buy_unit_price"
                            label="구입단가"

                            :validate-rules="{required: true}"
                            required
                            highlight

                            :placeholder="regionCurrency"
                            desc-msg=""

                            @update:value="emitTotalBuyPrice"
                        >
                            <div slot="bottom" class="w-full uk-text-danger uk-text-right">
                                통관시 전송되는 1개 상품 가격입니다.
                            </div>
                        </input-td-style>

                    </div>
                </app-shipping-reg-fieldset>

                <app-shipping-reg-fieldset theme="slim" class="mb-0d5rem" title="구매처">
                    <div class="uk-flex uk-flex-wrap uk-flex-top">



                        <input-td-style
                            class="uk-width-1-2 mb-0d5rem mr-0d5rem"
                            type="text"
                            input-size="small"

                            ref="p_vender_code"
                            :name="makeInputName('p_vender_code')"
                            v-model="columns.p_vender_code"
                            label="해외상품코드"
                            desc-msg="검수시 확인됩니다. 정확한 해외상품코드를 입력해 주세요."

                            placeholder="SKU No"
                        > </input-td-style>



                        <input-td-style
                            class="uk-width-expand mb-0d5rem"
                            type="text"
                            input-size="small"

                            ref="p_prod_code"
                            :name="makeInputName('p_prod_code')"
                            v-model="columns.p_prod_code"
                            label="상품코드"

                            placeholder="회원사 자체 관리코드"
                        > </input-td-style>



                        <input-td-style
                            class="uk-width-1-2 mb-0d5rem mr-0d5rem"
                            type="text"
                            input-size="small"

                            ref="p_vender_mall"
                            :name="makeInputName('p_vender_mall')"
                            v-model="columns.p_vender_mall"
                            label="쇼핑몰"

                            placeholder="예시 : amazon.com"
                        > </input-td-style>


                        <!-- 적격사업자번호 자리 -->
                        <div class="uk-width-expand mb-0d5rem"></div>




                        <input-td-style
                            class="w-full mb-0d5rem"
                            type="text"
                            input-size="small"

                            ref="p_vender_url"
                            :name="makeInputName('p_vender_url')"
                            v-model="columns.p_vender_url"
                            label="상세URL"
                            placeholder="해외 상세페이지 URL"
                            desc-msg="(일본) : 반드시 일본어 상세페이지로 입력하세요. 한글 상세인경우, 일본 수출통관이 지연됩니다"

                            :validate-rules="{required: true}"
                            required
                            highlight
                        > </input-td-style>

                        <input-td-style
                            class="w-full mb-0d5rem"
                            type="text"
                            input-size="small"

                            ref="p_img_url"
                            :name="makeInputName('p_img_url')"
                            v-model="columns.p_img_url"
                            label="이미지URL"

                            :validate-rules="{required: true}"
                            required
                            highlight
                        > </input-td-style>


                    </div>
                </app-shipping-reg-fieldset>

                <app-shipping-reg-fieldset theme="slim" class="mb-0d5rem" title="통관정보">
                    <div class="uk-flex uk-flex-wrap uk-flex-top">

                        <app-prod-hscode-on-register
                            class="w-full mb-0d5rem"
                            :name="makeInputName('p_hscode')"
                            v-model="columns.p_hscode"
                            :hscode-options="hscodeOptions"
                            :hscodefull-options="hscodefullOptions"

                            :validate-rules="{required: true}"
                            required
                            highlight
                        ></app-prod-hscode-on-register>




                        <input-td-style
                            class="uk-width-1-2 mb-0d5rem mr-0d5rem"
                            type="text"
                            input-size="small"

                            ref="p_type_name"
                            :name="makeInputName('p_type_name')"
                            v-model="columns.p_type_name"
                            label="품목명"

                            placeholder="e.g. CLOTHES"
                            desc-msg="영문으로 작성하세요"

                            :validate-rules="{required: true}"
                            required
                            highlight
                        > </input-td-style>

                        <div class="uk-width-expand mb-0d5rem"></div>

                        <!-- hs코드 설명 -->
                        <hscode-guide
                            class="w-full mb-0d5rem"
                        ></hscode-guide>
                    </div>
                </app-shipping-reg-fieldset>


            </div>


            <div class="uk-flex uk-flex-top w-60rem uk-flex-wrap">
                <div class="w-35rem mr-1rem">
                    <!-- 해외오더정보 -->
                    <app-shipping-reg-fieldset theme="slim" class="mb-2rem vendor" title="해외오더">
                        <div>
                            <input-td-style
                                class="w-full mb-0d5rem"
                                type="text"
                                input-size="small"

                                ref="p_buy_order_code"
                                :name="makeInputName('p_buy_order_code')"
                                v-model="columns.p_buy_order_code"
                                label="해외주문번호"
                            >
                                <div slot="label" class="font-bold">해외주문번호</div>
                            </input-td-style>

                            <input-td-style
                                class="w-full mb-0d5rem"
                                type="radio"
                                input-size="small"

                                ref="p_shipping_center"
                                :name="makeInputName('p_shipping_center')"
                                v-model="columns.p_shipping_center"
                                label="배송지"

                                :options="shippingCenterOptions"

                                desc-msg=""
                                :css-variables="{'--label-width': '6rem'}"
                            >
                                <div
                                    slot="input-bottom"
                                    class="uk-text-rightw uk-text-muted uk-text-small"
                                    v-if="hasShippingCenterOptionDe"
                                >
                                    * DE(델라웨어)로 배송시 반드시 [DE]를 선택하세요
                                </div>
                            </input-td-style>



                            <input-td-style
                                class="w-full mb-0d5rem"
                                type="text"
                                input-size="small"

                                ref="p_tracking_no"
                                :name="makeInputName('p_tracking_no')"
                                v-model="columns.p_tracking_no"
                                label="트래킹번호"

                                placeholder="해외 현지 택배번호"
                            >
                                <div slot="label" class="font-bold">트래킹번호</div>
                                <div slot="bottom" class="uk-text-danger uk-text-right">화물 도착전까지 반드시 입력해 주세요.</div>
                            </input-td-style>


                            <input-td-style
                                class="w-full mb-0d5rem"
                                type="text"
                                input-size="small"

                                ref="p_tracking_recipient_name"
                                :name="makeInputName('p_tracking_recipient_name')"
                                v-model="columns.p_tracking_recipient_name"
                                label="쉬핑네임"

                                placeholder="해외사이트 오더시, 입력한 영문이름"
                            > </input-td-style>

                            <input-td-style
                                class="w-full mb-0d5rem"
                                type="text"
                                input-size="small"

                                ref="p_tracking_onetime_pass"
                                :name="makeInputName('p_tracking_onetime_pass')"
                                v-model="columns.p_tracking_onetime_pass"
                                label="원타임패스워드"

                                placeholder="아마존 고가상품 배송시 해당"
                            > </input-td-style>


                        </div>
                    </app-shipping-reg-fieldset>

                    <!-- 보류요청 -->
                    <app-shipping-reg-fieldset theme="slim" class="mb-0d5rem hold-req" title="보류요청">

                        <div slot="title-desc">
                            <toggle-button
                                class="hold-req-checker"
                                :width="80"
                                color="#ee395b"

                                v-model="columns.write_hold_request"
                                :labels="{checked: '보류요청', unchecked: '요청안함'}"
                            ></toggle-button>
                            <input type="hidden" :name="makeInputName('write_hold_request')" :value="columns.write_hold_request ? 'yes' : 'no'" />
                        </div>

                        <input-td-style
                            class="w-full mb-0d5rem"
                            type="textarea"
                            input-size="small"

                            ref="hold_request_reason"
                            :name="makeInputName('hold_request_reason')"
                            v-model="columns.hold_request_reason"
                            label="보류사유"

                            :textarea-rows="3"
                            :disabled="! columns.write_hold_request"

                            placeholder="보류사유를 작성하세요."
                        > </input-td-style>
                    </app-shipping-reg-fieldset>

                </div>

                <!-- 회원사주문정보 -->
                <app-shipping-reg-fieldset theme="slim" class="uk-width-expand mb-0d5rem order" title="회원사 주문정보">
                    <div>
                        <!-- 회원사 주문정보 안내 -->
                        <div class="uk-text-right">
                            <app-guide-label-user-market
                                popup-direction="top-right"
                            ></app-guide-label-user-market>
                        </div>

                        <input-td-style
                            class="w-full mb-0d5rem"
                            type="text"
                            input-size="small"

                            ref="hp_order_name"
                            :name="makeInputName('hp_order_name')"
                            v-model="columns.hp_order_name"
                            label="주문자"
                        > </input-td-style>

                        <input-td-style
                            class="w-full mb-0d5rem"
                            type="text"
                            input-size="small"

                            ref="hp_order_id"
                            :name="makeInputName('hp_order_id')"
                            v-model="columns.hp_order_id"
                            label="주문자ID"
                        > </input-td-style>

                        <input-td-style
                            class="w-full mb-0d5rem"
                            type="text"
                            input-size="small"

                            ref="hp_order_at"
                            :name="makeInputName('hp_order_at')"
                            v-model="columns.hp_order_at"
                            label="주문일"

                            placeholder="ex) 2017-01-01"
                        > </input-td-style>

                        <input-td-style
                            class="w-full mb-0d5rem"
                            type="text"
                            input-size="small"

                            ref="hp_order_market"
                            :name="makeInputName('hp_order_market')"
                            v-model="columns.hp_order_market"
                            label="마켓명"
                        > </input-td-style>

                        <input-td-style
                            class="w-full mb-0d5rem"
                            type="text"
                            input-size="small"

                            ref="hp_order_seller"
                            :name="makeInputName('hp_order_seller')"
                            v-model="columns.hp_order_seller"
                            label="셀러ID"
                        > </input-td-style>

                        <input-td-style
                            class="w-full mb-0d5rem"
                            type="text"
                            input-size="small"

                            ref="hp_order_unit_price_krw"
                            :name="makeInputName('hp_order_unit_price_krw')"
                            v-model="columns.hp_order_unit_price_krw"
                            label="판매단가"

                            placeholder="KRW"
                        > </input-td-style>

                        <input-td-style
                            class="w-full mb-0d5rem"
                            type="text"
                            input-size="small"

                            ref="hp_sp_prod_code"
                            :name="makeInputName('hp_sp_prod_code')"
                            v-model="columns.hp_sp_prod_code"
                            label="배송상품코드"

                            desc-msg="중복등록제한용"
                        > </input-td-style>

                        <!-- 배송상품코드 기능 안내 -->
                        <div class="mb-0d5rem border-box p-0d5rem uk-text-left">
                            <i class="material-icons">info</i>
                            [배송상품코드]에 해당 마켓의 주문번호(유일한 번호)를 입력해 두시면 주문번호를 참고하실 수 있을 뿐만아니라, 배송신청서 중복 등록을 방지할 수 있습니다.
                            <div class="uk-text-right uk-margin-small-top">
                                <a href="https://global.gonelo.com/common/faqs/136" target="_blank" class="uk-button uk-button-small uk-button-dark">
                                    자세히읽기<i class="material-icons">open_in_new</i>
                                </a>
                            </div>

                        </div>
                    </div>
                </app-shipping-reg-fieldset>

                <!-- 메모 -->
                <app-shipping-reg-fieldset theme="slim" class="w-full mb-0d5rem" title="관리메모 / 검수시요청사항">
                    <div class="uk-flex uk-flex-wrap uk-flex-top">
                        <input-td-style
                            class="w-full mb-0d5rem"
                            type="textarea"
                            input-size="small"

                            ref="p_memo"
                            :name="makeInputName('p_memo')"
                            v-model="columns.p_memo"
                            label="관리메모"

                            placeholder="업체 관리메모 입니다. 고넬로에서는 참고하지 않습니다."
                            :textarea-rows="3"
                        > </input-td-style>

                        <input-td-style
                            class="w-full mb-0d5rem"
                            type="textarea"
                            input-size="small"

                            ref="check_request"
                            :name="makeInputName('check_request')"
                            v-model="columns.check_request"
                            label="검수시 요청사항"

                            :textarea-rows="3"

                            placeholder="창고 검수작업자에게 전달되는 내용으로 간결하고 명확하게 작성해주세요."
                        > </input-td-style>


                    </div>
                </app-shipping-reg-fieldset>
            </div>




        </div>



    </li>
</template>

<script>
    export default {
        components: {
            'upload': require('./img-upload.vue').default,
            'input-td-style': require('../input/ex/td-style.vue').default,
            'hscode-guide': require('../prod/hscode/guide.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            columns: {
                type: Object,
                required: true
            },
            index: {
                type: Number,
                required: true
            },
            duplicateButtonText: {
                type: String
            },
            removeButtonText: {
                type: String
            },
            removeButtonDisable: Boolean, // 삭제버튼 활성화여부

            /**
             * HS코드표 옵션 배열
             */
            hscodeOptions: {
                type: Array,
                default: () => {return [];}
            },

            /**
             * hs코드(코드별 전체품목) 옵션배열
             */
            hscodefullOptions: {
                type: Array,
                default: () => {return [];}
            },

            /**
             * 배송지 옵션 배열
             */
            shippingCenterOptions: {
                type: Array,
                default: () => {return [];}
            },


            /**
             * 지역기본 화폐단위
             */
            regionCurrency: {
                type: String,
            },
        },
        data: function () {
            return {

            };
        },
        computed: {
            /**
             * 배송지옵션중에 델라웨어(DE)를 보유하고 있는지 반환
             */
            hasShippingCenterOptionDe() {
                let opt = _.find(this.shippingCenterOptions, {val: 'DE'});
                return !!opt;
            },

        },
        watch: {
        },
        methods: {
            /**
             * 총 구입금액 관련 칼럼 변경되었음을 알리는 이벤트 발생
             * - 수량, 구입단가
             */
            emitTotalBuyPrice() {
                this.$emit('update:totalBuyPrice');
            },

            /**
             * 복제이벤트 발생
             */
            duplicate: function () {
                this.$emit('duplicate', this.index);
            },
            /**
             * 제거 이벤트 발생
             */
            remove: function () {
                this.$emit('remove', this.index)
            },
            changeInput: _.debounce(function (event) {
                // 검증구문 들어가면 됨
                //console.log(event.target.value);
            }, 500),
            /**
             * index 번호로 input 의 name을 작성
             */
            makeInputName: function (column_name) {
                return column_name + '_' + this.index;
            },

            /**
             * 업로드 이벤트 리스너
             */
            listenUploaded(uploaded) {
                this.columns.p_img_file_id = uploaded.id;
                this.columns.p_img_url = uploaded.full_url;
                //console.log(uploaded);
            },
        }
    }
</script>

<!-- 하위컴포넌트의 요소에 영향을 주기위해서 scope 설정하지않음. -->
<style lang="scss" scoped>
    .prod-component{
        // 순번
        .seq {
            background-color: #0070ff;
            color: #fff;
            font-size: 1.5rem;
            font-weight: bold;

            border-radius: 50%;
            width: 2rem;
            height: 2rem;
            text-align: center;

            display: flex;
            justify-content: center;
            align-items: center;

        }

        // 이미지
        .img {
            width: 150px;
            margin-top: 20px;

            .blank-text {
                border: 1px solid #999;
                text-align: center;
                padding: 50px 0;
                background-color: #fff;
                color: #999;
            }

            img {
                width: 150px;
            }
        }

    }

    .hold-req-checker {
        margin-left: 75px;
    }
</style>